/**
* @description 系统全局配置
*/
export default {
  /**
  * @description 网站名称
  */
  webName: '',
  /**
   * @description 前端接口请求超时时间， 毫秒(默认为两分钟120000)
   */
  //  timeout: 1000 * 60 * 2, // 2分钟
  timeout: 1000 * 120,
  // 网页总结网址配置
  summarys: [
    {
      title: '头一波导航页',
      url: 'https://lenovo.ilive.cn/',
      // match: ['lenovo.ilive.cn', 'lenovo.ilive.cn'],
      match: 'lenovo.ilive.cn',
      desc: '头一波网址导航，便捷上网从这里开始。',
      content: '头一波网址导航，提供简单便捷的上网导航服务。为用户推荐有价值的、个性化的信息，领略未知世界的新边界。\n\n推荐搜索词：头一波网址导航、联想网址导航、联想浏览器',
      keywords: []
    },
    {
      title: '新标签页',
      url: 'https://nsl.lenovo.com.cn/#/index/index',
      // match: ['nsl.lenovo.com.cn', 'newtab'],
      match: 'newtab',
      desc: '联想浏览器新标签页，简洁、高效！',
      content: '联想浏览器新标签页，清新、简约、不简单！高度个性化自定义操作，定制您的专属起始页。\n\n推荐搜索词：联想、联想浏览器、联想浏览器官网',
      keywords: []
    },
    {
      title: '浏览器官网',
      url: 'http://browser.lenovo.com.cn/',
      // match: ['browser.lenovo.com.cn'],
      match: 'browser.lenovo.com.cn',
      desc: '联想浏览器，更快、更轻、更安全！',
      content: '联想浏览器是联想原厂出品的一款与众不同的高性能浏览器, 作为最常用的上网工具，与联想设备深度集成，具备卓越的性能和安全性。更快、更轻、更安全！\n联想浏览器不断探索AI与浏览器场景的融合，借助AI技术提升用户的搜索和浏览体验。此外，还推出了强大的PDF工具，在提供便捷浏览的同时，还具备编辑、转换等高级功能。\n在交互体验方面，始终保持创新，与时俱进，采用最新潮的交互方式，打造个性化的上网体验。\n\n推荐搜索词：联想、联想浏览器、联想浏览器官网',
      keywords: []
    },
    {
      title: '浏览器设置',
      url: 'slbrowser://settings/',
      // match: ['chrome://'],
      match: 'chrome://',
      desc: '联想浏览器，更快、更轻、更安全！',
      content: '联想浏览器设置页，重新定义你的上网体验\n\n推荐搜索词：联想、联想浏览器、联想浏览器官网',
      keywords: []
    },
    {
      title: 'SMB新标签页',
      url: 'https://go.lenovo.com.cn/',
      // match: ['go.lenovo.com.cn'],
      match: 'go.lenovo.com.cn',
      desc: '联想浏览器新标签页联想浏览器新标签页。',
      content: '联想浏览器极简新标签页，一个简洁干净的标签页，专注于极简办公领域\n\n推荐搜索词：联想、联想浏览器、联想浏览器官网',
      keywords: []
    }
  ]
}